import type { ReactNode } from "react";
import { useId } from "react";

import * as NavigationMenu from "@radix-ui/react-navigation-menu";

import * as theme from "./PageNavMenuSection.css";

export interface PageNavMenuSectionProps {
    label?: string;
    children: ReactNode;
}

// An item of the menu's one list rather than a list of its own: Radix scopes
// arrow keys to a list, so separate lists would trap focus in each section.
export function PageNavMenuSection({
    label,
    children,
}: PageNavMenuSectionProps) {
    const labelId = useId();
    const hasLabel = label !== undefined;

    return (
        <NavigationMenu.Item className={theme.root}>
            {hasLabel && (
                <div id={labelId} className={theme.label}>
                    {label}
                </div>
            )}
            <ul
                aria-labelledby={hasLabel ? labelId : undefined}
                className={theme.rows}
            >
                {children}
            </ul>
        </NavigationMenu.Item>
    );
}
